<template>
  <div id="app">
    <keep-alive>
      <router-view ref="app-body-view" :key="$route.fullPath"
                   v-if="this.$route.meta.keepAlive"/>
    </keep-alive>
    <router-view ref="app-body-view" :key="$route.fullPath"
                 v-if="!this.$route.meta.keepAlive"/>

  </div>
</template>

<script>

import store from "./store";

export default {
  name: 'App'
}
</script>

<style>
@font-face {
  font-family: "iconfont"; /* project id 1908491 */
  src: url("//at.alicdn.com/t/font_1908491_cyqu8yxbg0m.eot");
  src: url("//at.alicdn.com/t/font_1908491_cyqu8yxbg0m.eot?#iefix")
      format("embedded-opentype"),
    url("//at.alicdn.com/t/font_1908491_cyqu8yxbg0m.woff2") format("woff2"),
    url("//at.alicdn.com/t/font_1908491_cyqu8yxbg0m.woff") format("woff"),
    url("//at.alicdn.com/t/font_1908491_cyqu8yxbg0m.ttf") format("truetype"),
    url("//at.alicdn.com/t/font_1908491_cyqu8yxbg0m.svg#iconfont") format("svg");
}
.iconfont {
  font-family: "iconfont" !important;
  font-size: 16px;
  font-style: normal;
  -webkit-font-smoothing: antialiased;
  -webkit-text-stroke-width: 0.2px;
  -moz-osx-font-smoothing: grayscale;
}
#app {
  background: url("./assets/images/details_bg.png") no-repeat;
  -webkit-background-size: 100% 100%;
  background-size: 100% 100%;
  min-height: 100vh;


}

*,
*::before,
*::after {
  /*box-sizing: border-box;*/
}
</style>



// WEBPACK FOOTER //
// src/App.vue